import { useRequest } from 'ahooks'
import { useTheme } from 'antd-style'

import { applyAuctionHaltApi } from '@eastcoal/api/trade/auctionMember/applyAuctionHalt'

import { DraggableModal } from '@eastcoal/common/components/DraggableModal'
import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { FormItem } from '@eastcoal/formily/components/FormItem'
import { SchemaForm } from '@eastcoal/formily/components/SchemaForm'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'
import { TextArea } from '@eastcoal/formily/components/TextArea'
import { UploadFile } from '@eastcoal/formily/components/UploadFile'
import { useCreationForm } from '@eastcoal/formily/hooks/useCreationForm'

import { useAuctionListStore } from '../../../Store/hooks/useStore'

const schema: SchemaItem[] = [
  {
    type: 'string',
    name: 'reason',
    title: '原因',
    required: true,
    'x-decorator': FormItem,
    'x-component': TextArea,
    'x-component-props': {
      placeholder: '请输入终止原因'
    }
  },
  {
    type: 'array',
    name: 'ossIds',
    title: '附件',
    required: true,
    'x-decorator': FormItem,
    'x-component': UploadFile
  }
]

export const AuctionHaltFormModal = () => {
  const form = useCreationForm()
  const { message } = useFeedback()
  const { tableRef, currentAuction, haltFormVisible, toggleHaltFormVisible } =
    useAuctionListStore(state =>
      pick(state, [
        'tableRef',
        'currentAuction',
        'haltFormVisible',
        'toggleHaltFormVisible'
      ])
    )
  const { loading, runAsync } = useRequest(applyAuctionHaltApi, {
    manual: true,
    onSuccess() {
      message.success('竞价终止成功')
      tableRef.current?.reload()
    }
  })

  const closeModal = () => {
    toggleHaltFormVisible(false)
  }

  const handleSubmit = () => {
    form.submit(async values => {
      await runAsync({
        auctionId: currentAuction?.id,
        ...values
      })
      closeModal()
    })
  }

  const theme = useTheme()

  return (
    <DraggableModal
      okText='提交'
      open={haltFormVisible}
      title={`${currentAuction?.title}-终止交易`}
      width={640}
      mask={{
        closable: false
      }}
      okButtonProps={{
        loading: loading
      }}
      styles={{
        body: {
          marginBlockStart: theme.marginLG
        }
      }}
      onCancel={closeModal}
      onOk={handleSubmit}
    >
      <SchemaForm
        form={form}
        name='applyAuctionHalfForm'
        schema={schema}
        grid={{
          columns: 1
        }}
        layout={{
          labelWidth: '4em'
        }}
      />
    </DraggableModal>
  )
}
